import type { Schemas } from "@softmax/observatory-client/types";
import type { LiveState, FinishedRound } from "./types";
export function liveOf({
  rounds,
  cadenceMinutes,
}: {
  readonly rounds: {
    readonly entries: Schemas["RoundListPublic"]["entries"];
  } | null;
  readonly cadenceMinutes: number | null;
}): LiveState {
  const latest = rounds?.entries[0] ?? null;
  const done = rounds?.entries.find((r) => r.completed_at) ?? null;
  const prev: FinishedRound | null =
    done?.completed_at != null
      ? { round: done.round_number, at: done.completed_at }
      : null;

  if (latest?.status === "running")
    return {
      kind: "running",
      round: latest.round_number,
      startedAt: latest.started_at ?? latest.created_at,
    };

  if (latest?.status === "pending")
    return { kind: "queued", round: latest.round_number, prev };

  if (latest && cadenceMinutes)
    return {
      kind: "next",
      round: latest.round_number + 1,
      at: new Date(
        new Date(latest.created_at).getTime() + cadenceMinutes * 60e3,
      ).toISOString(),
      prev,
    };

  return { kind: "unknown" };
}
